import { render, staticRenderFns } from "./CongruenceSimilarityViz.vue?vue&type=template&id=0f8a0c97&scoped=true"
import script from "./CongruenceSimilarityViz.vue?vue&type=script&lang=js"
export * from "./CongruenceSimilarityViz.vue?vue&type=script&lang=js"
import style0 from "./CongruenceSimilarityViz.vue?vue&type=style&index=0&id=0f8a0c97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8a0c97",
  null
  
)

export default component.exports